module.exports = __webpack_public_path__ + "static/1-c4d7845990897baa604835186a88d824.png";